import * as React from "react"
import ExportTableComponent, { RowSetType, ColumnType, DataExport } from "./export-table-component"
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import * as actionCreators from "../../../action-creators"
import { ReducerState } from "../../../reducer";
import { LocalAuthority }from "../../../model";

class ExportTable extends React.Component<ExportTableProps & ReducerState, State> {
	private readonly filename: string
	private readonly years: number[]

	constructor(props: Readonly<ExportTableProps & ReducerState>) {
		super(props)
		const localAuthority: LocalAuthority = this.props.currentLocalAuthority
		const operation = this.props.operation ? "fonctionnement" : "investissement"
		const receipts = this.props.receipts ? "recettes" : "depenses"
		const today = new Date()
		const date = `${today.getFullYear()}_${today.getMonth()+1}_${today.getDate()}`
		this.filename = `${localAuthority.slug}_${operation}_${receipts}_${date}`
		this.state = {
			chapters: [],
			data: [],
			showExport: false,
		}
	}

	componentDidMount() {
		if (!this.props.data) return
		const chapters = this.buildChapters(this.props.data)
		const data = this.buildData(chapters)
		this.setState({ chapters, data })
	}

	componentWillReceiveProps(props) {
		if (!props.data) return
		const chapters = this.buildChapters(props.data)
		const data = this.buildData(chapters)
		this.setState({ chapters, data })
	}

	render() {
		return <ExportTableComponent
						data={this.state.data}
						chapters={this.state.chapters}
						filename={this.filename}
						onClickCheckAllChapter={(e, allChecked) => this.handleCheckAllChapter(e, allChecked)}
						onClickCloseButton={this.handleCloseModal}
						onClickSelectChapter={(i, e) => this.handleSelectChapter(i, e)}
						title={this.props.receipts ? "Recettes" : "Dépenses"}
						showExport={this.state.showExport}
						/>
	}
	/**
	 * Méthode de création de la liste des chapitres par les données.
	 */
	private buildChapters(data: any[]) {
		let chapters = data.map(row => {
			let label  = row["chapter.label"]
			let number = row["chapter.number"]
			if (number === "undefined") number = ""
			return { number: number ? number : "", label: label ? label : "Non chapitré", checked: true }
		})
		return chapters
	}

	/**
	 * Méthode pour fermer la modal.
	 */
	private handleCloseModal(event: React.SyntheticEvent<Element>): void {
		event.preventDefault()
		this.setState({ showExport: false })
	}

	/**
	 * Méthode de création des colonnes pour le fichier xlsx.
	 */
	private getColumns() {
		const years = this.props.years
		let columns: ColumnType[] = [
			{ title: "Numéro" },
			{ title: "Libellé", width: { wch: 80 } },
			...years.map((y) => { return { title: y.toString() }})
		]
		return columns
	}

	/**
	 * Méthode qui génère le fichier xlsx suivant les différents chapitres cochés.
	 */
	private buildData(chapters: any[]) {
		const sortedData = this.props.data
		const dataReduced: RowSetType[] = sortedData.reduce((prev, row) => {
			const label  = row["chapter.label"]
			const number = row["chapter.number"]

			if (chapters.find(ch => ch.label === label && ch.checked === true)) {

				const dataSetChapter: RowSetType[] = [
					{ value: number ? number : null, style: { font: { bold: true } }},
					{ value: label ? label : "", style: { font: { bold: true } }},
					...this.props.years.map(y => {
						return { value: row[y.toString()], style: { font: { bold: true } }}
					})
				]

				this.populateDataExport(dataSetChapter, prev, row._subRows)
			}
			return prev
		}, [])

		const columns: ColumnType[] = this.getColumns()
		const data: RowSetType[] = dataReduced

		const dataExport: DataExport[] = [{ columns, data }]

		return dataExport
	}

	/**
	 * Méthode associée au bouton "Tout cocher" / "Tout décocher".
	 * @param e Event react
	 */
	private handleCheckAllChapter(e: React.SyntheticEvent<Element>, allChecked: boolean) {
		const chapters = this.state.chapters
		const target = e.target as HTMLInputElement

		if (allChecked) {
			chapters.forEach(chapter => {
				chapter.checked = false
			})
		} else {
			chapters.forEach(chapter => {
				chapter.checked = true
			})
		}
		const data = this.buildData(chapters)
		this.setState({ chapters, data })
	}

	/**
	 * Méthode associé pour cocher ou décocher un chapitre.
	 * @param index Index de la ligne contenu dans les données.
	 * @param e Event react
	 */
	private handleSelectChapter(index: number, e: React.SyntheticEvent<Element>): void {
		const chapters = this.state.chapters
		chapters[index].checked = !chapters[index].checked
		const data = this.buildData(chapters)
		this.setState({ chapters, data })
	}

	/**
	 * Méthode de "remplissage" de la donnée.
	 */
	private populateDataExport(dataSetChapter, prev, accounts): void {
		prev.push(dataSetChapter)
		accounts.forEach(acc => {
			const label = acc["account.label"]
			const number = acc["account.number"]
			const dataSetAccount: RowSetType[] = [
				{ value: number ? number : null},
				{ value: label ? label : ""},
				...this.props.years.map(y => {
					return { value: acc[y.toString()] ? acc[y.toString()].amount : 0 }
				})
			]
			prev.push(dataSetAccount)
		})
	}
}

const mapStateToProps = (state: ReducerState) => state
const mapDispatchToProps = (dispatch: Dispatch<any>) => (
	{ actions: bindActionCreators(actionCreators, dispatch) }
)

export default connect(mapStateToProps, mapDispatchToProps)(ExportTable);

interface State {
	chapters: any[]
	data: any
	showExport: boolean
}

interface ExportTableProps {
	data: any
	operation: boolean
	receipts: boolean
	title: string
	years: number[]
}


// WEBPACK FOOTER //
// ./src/component/observation-table/export-table/index.tsx